export enum ComponentOrigin {
  Capture = 'capture',
  Upload = 'upload',
  CaptureUpload = 'capture_upload',
}

export enum Languages {
  En = 'en',
  Es = 'es',
}

export enum LocationTypes {
  GPS = 'GPS',
  NFC = 'NFC',
  QR = 'QR',
  BEACON = 'BEACON',
}

export interface IDistance {
  outside: boolean;
  meters: number;
}

export interface IPosition {
  lat: number;
  lon: number;
}

/**
 * Sync with: services/src/schemas/TPositionDetailed.ts
 */
export interface IPositionDetailed {
  location: IPosition;
  id?: number;
  alt?: number;
  accuracy?: number;
  speed?: number;
  heading?: number;
  timestamp: number;
  uid: string;
}

export interface ILocation {
  id: string;
  name: string;
  type: LocationTypes;

  token?: string; // when "type" is NFC, QR or BEACON
  distance?: IDistance; // when "type" is GPS or BEACON
  divId?: string;
  position?: IPosition; // when "type" is GPS
  uid?: string;
  createdAt?: any;
  updatedAt?: any;
}

export enum ComponentTypes {
  Check = 'check',
  File = 'file',
  Number = 'number',
  Photo = 'photo',
  Tag = 'tag',
  Text = 'text',
  Toggle = 'toggle',
  Video = 'video',
  Select = 'select',
  Date = 'date',
  Signature = 'signature',
}
